<template>
	<div id="pageRoot">

		<p class="textBase appearAnimationB" id="text01" style="z-index: 6">
			Para realizar esta actividad, vuelve a leer el cuento "Venancio vuela bajito".
		</p>

		<div class="text-box-a hover-animation-a" id="textBox01">
			<p class="textBase" id="textBox01Text">
				Completa los enunciados<br>
				con estas expresiones.
			</p>
		</div>

		<div class="basicItem01" id="tag01">
			<p class="textBase tagText">
				cuadras a la carnicería.
			</p>
		</div>
		<div class="basicItem01" id="tag02">
			<p class="textBase tagText">
				vuelta por el aire!
			</p>
		</div>


		<p class="textBase appearAnimationB" id="text02" style="z-index: 6">
			Saltaba cada vez más alto. ¡Daba media
		</p>

		<p class="textBase appearAnimationB" id="text03" style="z-index: 6">
			Finalmente aprendió a volar. Así voló dos
		</p>

		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 id="inputField01" class="pageElement" style=
		"z-index: 7"/>
		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=2 id="inputField02" class="pageElement" style=
		"z-index: 7"/>

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<img id="fixed" src="/pages/img/sordo/svgPage82Fixed.svg">
		<span class="footer-page footer-write"></span>
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
.tagText
{
position: absolute;
left: 0px;
right: 0px;
top: 5px;
bottom: 0px;

font-size: 36px;
line-height: 49px;
text-align: center;

color: #FEFAFA;
}
#fixed
{
position: absolute;
width: 870.02px;
height: 642px;
left: 41px;
top: 32px;
}
#text01
{
position: absolute;
width: 944px;
height: 35px;
left: 88px;
top: 113px;
}
#text02
{
position: absolute;
width: 443px;
height: 35px;
left: 44px;
top: 477px;
}
#text03
{
position: absolute;
width: 499px;
height: 35px;
left: 44px;
top: 567px;
}
#textBox01
{
position: absolute;
width: 382.95px;
height: 278.93px;
left: 651.14px;
top: 250px;
background-image: url(/pages/img/sordo/svgPage81Textbox01.svg);
}
#textBox01Text
{
position: absolute;
width: 327px;
height: 75px;
left: 24.86px;
top: 32.25px;

font-size: 26px;
line-height: 35px;
text-align: center;

color: #FBF8F8;
}
#inputField01
{
position: absolute;
width: 368px;
left: 496px;
top: 462px;
font-size: 33px;
}
#inputField02
{
position: absolute;
width: 352px;
left: 512px;
top: 550px;
font-size: 33px;
}
#tag01
{
position: absolute;
width: 434px;
height: 70.55px;
left: 81px;
top: 230px;
z-index: 3;
background-image: url(/pages/img/sordo/svgPage71TagLong.svg);
background-size: cover;
background-repeat: no-repeat;
}
#tag02
{
position: absolute;
width: 335px;
height: 70.55px;
left: 133px;
top: 340px;
z-index: 3;
background-image: url(/pages/img/sordo/svgPage75TagMedium.svg);
background-size: cover;
background-repeat: no-repeat;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p83/V102.mp4"]
    }
  }
}
</script>